import { useFeatureUsageApi } from '../../../common/hooks/use-feature-usage-api.hook';
import { PageViewTracker } from './PageViewTracker';

/**
 * In the vendor portal: the pages a vendor's team opens, for Vendor usage.
 * The API leaves out Ardealy support working in the account (Act-as).
 */
export function VendorUsageTracker() {
  const api = useFeatureUsageApi();
  return <PageViewTracker record={api.recordViews} />;
}
